/**
 * Converts aggregated bucket data into a running cumulative sum.
 *
 * Each attribute series is accumulated independently.
 * Input is not mutated — a new object is returned.
 *
 * @param {Object<string, Array<{bucket_label:string, bucket_start:string, bucket_end:string, total_value:number, item_count:number}>>} seriesMap
 *   Map of attributeName → array of chart items (the shape returned by the backend).
 * @returns {Object<string, Array>} A new map with cumulative totals.
 */
export function toCumulative(seriesMap) {
  const result = {};

  for (const [attr, items] of Object.entries(seriesMap)) {
    let runningSum = 0;
    result[attr] = items.map((item) => {
      runningSum += item.total_value;
      return { ...item, total_value: runningSum };
    });
  }

  return result;
}
